var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_599_1183)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6647 23.1271L20.6688 10.9776C20.4939 10.68 20.2444 10.4332 19.9448 10.2617C19.6452 10.0902 19.306 10 18.9608 10C18.6156 10 18.2764 10.0902 17.9768 10.2617C17.6772 10.4332 17.4276 10.68 17.2528 10.9776L10.2569 23.1271C10.0886 23.415 10 23.7425 10 24.0759C10 24.4094 10.0886 24.7368 10.2569 25.0247C10.4294 25.3242 10.6786 25.5723 10.9787 25.7437C11.2789 25.9151 11.6192 26.0035 11.9648 25.9999H25.9567C26.302 26.0032 26.642 25.9146 26.9419 25.7433C27.2417 25.5719 27.4906 25.3239 27.6631 25.0247C27.8315 24.7369 27.9205 24.4096 27.9207 24.0761C27.921 23.7427 27.8326 23.4152 27.6647 23.1271ZM18.3208 16.4C18.3208 16.2303 18.3882 16.0675 18.5082 15.9474C18.6282 15.8274 18.791 15.76 18.9608 15.76C19.1305 15.76 19.2933 15.8274 19.4133 15.9474C19.5333 16.0675 19.6008 16.2303 19.6008 16.4V19.6C19.6008 19.7697 19.5333 19.9325 19.4133 20.0525C19.2933 20.1725 19.1305 20.24 18.9608 20.24C18.791 20.24 18.6282 20.1725 18.5082 20.0525C18.3882 19.9325 18.3208 19.7697 18.3208 19.6V16.4ZM18.9608 23.4399C18.7709 23.4399 18.5853 23.3836 18.4274 23.2781C18.2696 23.1726 18.1465 23.0227 18.0739 22.8473C18.0012 22.6719 17.9822 22.4789 18.0192 22.2926C18.0563 22.1064 18.1477 21.9354 18.282 21.8011C18.4162 21.6669 18.5873 21.5754 18.7735 21.5384C18.9597 21.5013 19.1527 21.5204 19.3281 21.593C19.5036 21.6657 19.6535 21.7887 19.759 21.9466C19.8645 22.1045 19.9208 22.2901 19.9208 22.4799C19.9208 22.7345 19.8196 22.9787 19.6396 23.1587C19.4596 23.3388 19.2154 23.4399 18.9608 23.4399Z",
    fill: "#BD1D23"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_599_1183",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_599_1183"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.741176 0 0 0 0 0.113725 0 0 0 0 0.137255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_599_1183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_599_1183",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.e8c9cace3c9e40cba5695b30997663b7.svg";
export { ForwardRef as ReactComponent };